/**
 * Environment: DLL - Desarrollo
 * Variables que se cargan cuando se ejecuta con perfil de desarrollo
 */
export const environment = {
  /**
   * indica si el ambiente es productivo, cuando es true se habilita la configuracion de angular para aplicaciones en producción
   */
  production: false,
  profile: 'dll',
  useMocks: false,
  enableDebug: true,
  identity: {
    useMocks: false
  },
  backend: {
    context: '/api',
    baseUrl: 'https://apigirop.dllosura.com/api',
    actuatorUrl: 'https://apigirop.dllosura.com/api/servicios/actuator'
  },
  features: {
    dashboard: true,
    testing: true
  }
};
